<div class="border-bottom" id="result-list-top-area">
  <ng-container *ngTemplateOutlet="toolbar"></ng-container>
</div>

@if ((resultListMode$ | async) === 'tile') {
  <cat-result-list-tile
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    class="flex-1"
  ></cat-result-list-tile>
}

@if ((resultListMode$ | async) === 'basic' || (resultListMode$ | async) === null) {
  <cat-result-list-basic
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [highlighting]="searchItem.search.highlighting"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    [sort]="searchItem.search_sort"
    class="flex-1"
  ></cat-result-list-basic>
}

@if ((resultListMode$ | async) === 'basic-compact') {
  <cat-result-list-basic-compact
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [highlighting]="searchItem.search.highlighting"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    [sort]="searchItem.search_sort"
    class="flex-1"
  ></cat-result-list-basic-compact>
}

@if ((resultListMode$ | async) === 'tile-single-column') {
  <cat-result-list-tile
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    [singleColumn]="true"
    class="flex-1"
  ></cat-result-list-tile>
}

@if ((resultListMode$ | async) === 'masonry') {
  <cat-result-list-masonry
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    class="flex-1"
  ></cat-result-list-masonry>
}

@if ((resultListMode$ | async) === 'masonry-simple') {
  <cat-result-list-masonry-simple
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    class="flex-1"
  ></cat-result-list-masonry-simple>
}

@if ((resultListMode$ | async) === 'tile-single-column-simple') {
  <cat-result-list-tile-simple
    (detail)="onDetail($event)"
    [coreId]="searchItem.coreId"
    [items]="searchItem.search.recordList"
    [searchItem]="searchItem"
    class="flex-1"
  ></cat-result-list-tile-simple>
}

<div class="border-top">
  <ng-container *ngTemplateOutlet="toolbar"></ng-container>
</div>

<ng-template #toolbar>
  <div class="p-1">
    <cat-result-list-toolbar [searchItem]="searchItem" (pageChange)="onPageChange($event)"></cat-result-list-toolbar>
  </div>
</ng-template>
